import { useCallback } from "react";
import { Alert, Button, Checkbox, Stack, Title } from "@mantine/core";
import type { LegacyReviewForm } from "../../../utils/legacyReviewForm";
import LegacySpecimenFields from "./LegacySpecimenFields";

export default function LegacySpecimensFields({
  form,
}: {
  form: LegacyReviewForm;
}) {
  const handleAdd = useCallback(
    () =>
      form.insertListItem("specimens", {
        number: "",
        evidenceText: "",
        grossText: "",
        diagnosisText: "",
        microscopicText: "",
        completedSlides: [],
      }),
    [form]
  );
  return (
    <Stack gap="md">
      <Title order={3}>Optional specimens and slides</Title>
      <Checkbox
        label="Create the reviewed specimens and completed slides below"
        {...form.getInputProps("includeSpecimens", { type: "checkbox" })}
      />
      {form.values.includeSpecimens && (
        <Stack gap="md">
          <Alert color="blue">
            Add only specimens supported by exact report text. Completed slides
            need recorded evidence; no blocks or slide work will be inferred.
          </Alert>
          {form.values.specimens.map((specimen, index) => (
            <LegacySpecimenFields key={index} form={form} index={index} />
          ))}
          <Button variant="light" onClick={handleAdd}>
            Add evidenced specimen
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
